import Slick from 'slick-carousel/slick/slick';

export default $(()=>{

    // Open external links in new window // conflicts with Lightbox and https://css-tricks.com/use-target_blank/

    $('a.offsite-new-window').on('click', function(e) {
        var external = (
            !this.href.match(new RegExp(window.location.origin))
        );

        var empty = this.href == '';
        var js = this.href.match(/javascript/i);
        var file = this.href.match(/(\.pdf|\.dwg)/i) || this.href.match(/resource/i);

        if (!empty && !js && (external || file)) {
            window.open(this.href);
            e.preventDefault();
        }
    });

    $('.more-link > a.down').click(function(e) {
        e.preventDefault();
        $('.resources-grid--extra').slideToggle(500);
        $('.more-link > a.down').toggleClass('down-active');
    });


    $('.alert-bar .close-button').on('click', function(){
        $.get( "actions/anvil-module/anvil/hide-alert-bar", function( data ) {
            //console.log(data);
        });

        $(this.closest('.alert-bar')).hide();
    });


    // var userCompanyType = $('select#userCompanyType');
    // var shipToAccounts = $('div#shipToAccounts');
    // var inventoryRadios = $("input.inventoryAccessRadioButtons"); // radio buttons

    // registrationFormInventoryVisibility(userCompanyType.val());

    // userCompanyType.change(function(){
    //     registrationFormInventoryVisibility($(this).val());
    // });
    // inventoryRadios.change(function(){
    //     registrationFormAccountsVisibility();
    // });

    // function registrationFormInventoryVisibility(companyType)
    // {
    //     let userInventoryAccess = $('div#userInventoryAccess'); // container

    //     if (companyType == 'distributor') {
    //         userInventoryAccess.show();
    //         inventoryRadios.attr('required', true);

    //         registrationFormAccountsVisibility();
    //     } else {
    //         shipToAccounts.hide();
    //         userInventoryAccess.hide();
    //         inventoryRadios.attr('required', false);
    //     }
    // }

    // function registrationFormAccountsVisibility()
    // {
    //     let selected = $("input.inventoryAccessRadioButtons:checked");

    //     if (selected.length && selected.val() == 'Inventory and Pricing') {
    //         shipToAccounts.show();
    //     } else {
    //         shipToAccounts.hide();
    //     }
    // }
});